import { useContext } from "react";
import { styled } from "styled-components";
import { PlatformIcon } from "@dialogueconsulting/sked-ui";
import { AccountContext } from "./account-context";
import { getPlatformName } from "../../../../utils/accounts";
import {
  AccountPlatformType,
  platformAccountNameMap,
} from "../../../../shared/types/accounts";
import { PlatformNameToPlatformTypeMap } from "../../../../features/post/format-post";
import { getAccountPlatformType } from "../../libs/account-platform";

type AccountPlatformIconProps = {
  account?: {
    platformId?: string | null;
    platformType?: AccountPlatformType;
  };
  className?: string;
  useYtRedPlayIcon?: boolean;
};

export const AccountPlatformIcon = styled((props: AccountPlatformIconProps) => {
  const account = props.account || useContext(AccountContext);

  let platformType = getPlatformName(getAccountPlatformType(account));

  const hasPlatform = Boolean(account?.platformId);
  const otherTypesWithConnectionOptions = [
    PlatformNameToPlatformTypeMap.tiktok,
    PlatformNameToPlatformTypeMap.threads,
  ];
  const isOtherTypeWithConnectionOption =
    account?.platformType &&
    otherTypesWithConnectionOptions.includes(account.platformType);

  if (isOtherTypeWithConnectionOption && !hasPlatform) {
    platformType = platformAccountNameMap.OT;
  }

  return (
    <PlatformIcon
      className={props.className}
      platform={platformType}
      youtubeRedPlay={props.useYtRedPlayIcon}
    />
  );
})``;
